"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JourneyTypes_1 = require("../../../../../../common/enum/JourneyTypes");
var navigation = {
    getActiveStep: function (pathname, steps, reserveOnlineJourney) {
        var activeStep = {
            index: 0,
            translationKey: '',
        };
        var journeyType = reserveOnlineJourney ? JourneyTypes_1.JourneyTypes.RESERVE_ONLINE : JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP;
        steps.forEach(function (step, index) {
            if (step.pathname === pathname) {
                activeStep = {
                    index: index,
                    translationKey: "trans__checkout__general__title_" + journeyType + "_" + step.label,
                };
            }
        });
        return activeStep;
    },
};
exports.default = navigation;
